import { Card, CardContent, CardHeader, SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { Id } from "@turf/helpers"

import { PromotionData } from "providers/venue/types"

import { FeatureCarouselLayout } from "components/domains/features"

interface IPromotionsCarouselProps {
  sx?: SxProps
  headerText: string
  promotions: PromotionData[]
  onClickCard?: (id: Id) => void
}

export const PromotionsCarousel = ({
  sx = {},
  headerText,
  promotions,
  onClickCard = () => {},
  ...props
}: IPromotionsCarouselProps) => {
  const theme = useTheme()

  const { promotionCarouselOption } =
    theme.components[`PromotionsCarousel`].defaultProps || {}

  const { styleOverrides } = theme.components[`PromotionsCarousel`] || {}
  const { root, header, cardContent, carouselContainer, carousel } =
    styleOverrides

  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <CardHeader title={headerText} sx={header} />
      <CardContent sx={cardContent}>
        <FeatureCarouselLayout
          sx={carouselContainer}
          features={promotions}
          carouselOption={promotionCarouselOption}
          carouselSx={carousel}
          onClickCard={onClickCard}
        />
      </CardContent>
    </Card>
  )
}
